module.exports = __webpack_public_path__ + "img/p3.7efba41c.png";